import { render, staticRenderFns } from "./BaseLinedCard.vue?vue&type=template&id=79c89ea3&scoped=true&"
import script from "./BaseLinedCard.vue?vue&type=script&lang=js&"
export * from "./BaseLinedCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseLinedCard.vue?vue&type=style&index=0&id=79c89ea3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c89ea3",
  null
  
)

export default component.exports